import React, { ReactElement } from 'react'
import '@/css/chat.css'
import ChatBar from '@/components/chat/ChatBar'
import ChatBody from '@/components/chat/ChatBody'
import ChatFooter from '@/components/chat/ChatFooter'
import { ArtData } from '@/database/art'

const Chat = ({ artData }: { artData?: ArtData }): ReactElement => {
    return (
        <div className="menu-wrapper-column header-container center ">
            <div className={artData ? 'artwork-box' : ''}>
                <ChatBar artData={artData} />
                <div className="">
                    <ChatBody artData={artData} />
                    <ChatFooter artData={artData} />
                </div>
            </div>
        </div>
    )
}

export default Chat
